/* eslint-disable no-undef */
import vClickOutside from "v-click-outside";
import { createNamespacedHelpers } from "vuex";
import CheckBox from "@/components/checkBox/checkBox.vue";

const {
		mapMutations: userMutations,
		mapActions: userActions,
		mapGetters: userGetters,
	} = createNamespacedHelpers("user"),
	{
		mapMutations: filtersMutations,
		mapGetters: filtersGetters,
		mapActions: filtersActions,
	} = createNamespacedHelpers("filters");

export default {
	props: {
		trackEventSource: String,
		type: String,
		list: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			required: false,
		},
		active: [String, Object],
		tooltip: Boolean,
		tooltipContent: [Object, Array],
		local: {
			type: Boolean,
			default: () => false,
		},
		value: {
			type: [String, Object],
			required: false,
		},
		period: String,
	},

	components: { CheckBox },

	data() {
		return {
			showList: false,
			activeFilter: "",
		};
	},

	computed: {
		...userGetters(["properties", "activeProperty", "activeOutlet", "deployments", "selectedDevicesFilter"]),

		...filtersGetters([
			"activePeriod",
			"periods",
			"activeCompareTo",
			"activeCompareToTranslation",
			"compareToDropdownItems",
			"activeWasteType",
			"wasteTypes",
		]),

		selectedDevicesIds,
		computedActivePeriod,
		totalNumberOfDevices,
	},

	methods: {
		toggleDropdown,
		closeDropdown,
		onSelectCompareTo,
		onSelectProperty,
		onSelectOutlet,
		onSelectPeriod,
		onSelectWasteType,
		onSelectDevice,
		parseList,
		makeTranslationKey,

		...userMutations(["setSelectedDevices", "toggleSelectedDevice"]),

		...userActions(["selectProperty", "selectOutlet"]),

		...filtersMutations(["setActiveCompareTo", "setActiveWasteType"]),

		...filtersActions(["selectPeriod"]),
	},

	watch: {
		list: function (val) {
			this.list = val;
		},
		active: function (val) {
			this.activeFilter = val;
		},
		date: function () {
			this.showList = false;
		},
	},

	directives: { clickOutside: vClickOutside.directive },
};

function parseList(list) {
	// remove duplicates
	list = Array.from(new Set(list.map(JSON.stringify))).map(JSON.parse);
	return list;
}

function toggleDropdown() {
	this.showList = !this.showList;
}

function onSelectCompareTo(compareTo) {
	this.setActiveCompareTo(compareTo);

	this.$eventBus.$emit("reloadComponentData");
	this.showList = false;

	this.$ma.trackEvent({
		action: "Head filter Click",
		properties: {
			Value: {
				Property: "Compare To",
				Period: period,
			},
			Component: this.$route.name,
		},
	});
}

function onSelectPeriod(period) {
	if (this.local) this.$emit("input", period);
	else {
		this.selectPeriod(period);
		this.$eventBus.$emit("setCalendar");
		this.$eventBus.$emit("reloadComponentData");
	}

	this.$ma.trackEvent({
		action: "Head filter Click",
		properties: {
			Value: {
				Property: "Period",
				Period: period,
			},
			Component: this.$route.name,
		},
	});

	this.showList = false;
}

function onSelectWasteType(wasteType) {
	this.setActiveWasteType(wasteType);

	this.$eventBus.$emit("reloadComponentData");
	this.showList = false;

	this.$ma.trackEvent({
		action: "Head filter Click",
		properties: {
			Value: {
				Property: "Waste Type",
				Period: period,
			},
			Component: this.$route.name,
		},
	});
}

function onSelectProperty(property) {
	this.selectProperty({ property });

	// Reset dropdowns
	this.$eventBus.$emit("destroyFilters");
	this.showList = false;
	this.$utils.initMixpanelBeforeTrack(this);
}

function onSelectOutlet(outlet) {
	this.selectOutlet(outlet);

	// Reset dropdowns
	this.$eventBus.$emit("destroyFilters");
	this.showList = false;
	this.$utils.initMixpanelBeforeTrack(this);
}

function onSelectDevice(deployment) {
	if (deployment) this.toggleSelectedDevice(deployment);
	else {
		const allSelected = this.selectedDevicesFilter.length === this.totalNumberOfDevices;
		this.setSelectedDevices(allSelected ? [this.deployments[0]] : [...this.deployments]);
	}

	this.$eventBus.$emit("reloadComponentData");

	this.$ma.trackEvent({
		action: "Head filter Click",
		properties: {
			Value: {
				Property: "Devices",
				Period: period,
			},
			Component: this.$route.name,
		},
	});
}

function closeDropdown() {
	this.showList = false;
}

function makeTranslationKey(activeCompareTo, activePeriod) {
	if (typeof activeCompareTo === "number") {
		// if the activeCompareTo is a number, that means that it is a year
		return activeCompareTo;
	}
	return `filters_compare_${activePeriod}.${activeCompareTo}`;
}

function selectedDevicesIds() {
	return this.selectedDevicesFilter;
}

// number of distinct devices
function totalNumberOfDevices() {
	const allDevices = this.deployments.reduce((devices, deployment) => {
		devices.push(...deployment.deployment_device_ids);
		return devices;
	}, []);
	return [...new Set(allDevices)].length;
}

function computedActivePeriod() {
	return this.local ? this.value : this.activePeriod;
}
